import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../helper/Api";
import Toastify from "../helper/Toastify";

const initialState = {
    isLoading: false,
    isRefresh: false,
    couponsData: {},
    applyCouponData: {},
    errorMsg: "",
    isError: false
}


export const getAllCoupons = createAsyncThunk('getAllCoupons', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.getAllCoupons(body);
        if (status === 200) {
            //get categories data
            dispatch(setAllCoupons(data.data))
        }
        return data.data
    } catch (err) {
        // Toastify.error(err.response.data.message)
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)
export const applyCoupon = createAsyncThunk('applyCoupon', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.applyCoupon(body);
        // console.log('data',data);
        

        if (status === 200) {
            // render otp screen
            dispatch(setApplyCoupon(data.data));
            // Toastify.success('Coupon applied successfully');
            // localStorage.setItem('data',data.data.discount)
            dispatch(setRefresh());
        }
        return data.data

    } catch (err) {
        Toastify.error(err.response.data.message);
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)


export const couponSlice = createSlice({
    name: "coupons",
    initialState,
    reducers: {

        setAllCoupons: (state, action) => {
            state.couponsData = action.payload
        },

        setApplyCoupon: (state, action) => {
            state.applyCouponData = action.payload
        },
        setRefresh: (state) => {
            state.isRefresh = !state.isRefresh
        },

    },
    extraReducers: (builder) => {

        // setAllProducts
        builder.addCase(getAllCoupons.pending, (state) => {
            state.isLoading = true
            state.isError = false
        })
        builder.addCase(getAllCoupons.fulfilled, (state, action) => {
            state.isLoading = false
            state.couponsData = action.payload
        })
        builder.addCase(getAllCoupons.rejected, (state, action) => {
            state.isLoading = false
            state.errorMsg = action.payload
        })
    }
})

export const {
    setRefresh,
    setAllCoupons,
    setApplyCoupon,
} = couponSlice.actions

export default couponSlice.reducer;